type RoundWithBookingIndex = {
  readonly bookingIndex?: number | null;
};

export const getRequestGroupCount = (
  rounds:
    | readonly (RoundWithBookingIndex | null | undefined)[]
    | null
    | undefined
): number => {
  const bookingIndexes = new Set(
    (rounds ?? [])
      .map((round) => round?.bookingIndex)
      .filter((bookingIndex): bookingIndex is number => bookingIndex != null)
  );

  return bookingIndexes.size > 0 ? bookingIndexes.size : 1;
};
